import {cdrToday} from 'api/cdrToday';
import Cookies from 'js-cookie';

const cdrTodayQuery = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        cdrToday({commit}, params) {
            return new Promise((resolve, reject) => {
                var keyword = params.keyword;
                var pagesize = params.psize;
                var currentPage = params.currentPage;
                cdrToday(keyword,pagesize,currentPage).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
    }
};

export default cdrTodayQuery;



// WEBPACK FOOTER //
// ./src/store/modules/cdrToday.js